import router from '@manager/router';
import type { App } from 'vue';

export function routerInit(app: App) {
  app.use(router);
}
